<div fxLayout="row" class="list-options " fxLayoutGap="12px">
  <ng-container *ngIf="loaded; else noDataLoaded">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between"
      fxLayoutGap="12px"
      class="item"
      *ngFor="let item of items; let last = last"
    >
      <div fxLayout="row" fxLayoutGap="12px">
        <div class="icon">
          <mat-icon [svgIcon]="item.icon" [class.mr-20]="last" class="icon-lg"></mat-icon>
        </div>
        <div class="label">
          <span class="text first">{{ 'dashboard.' + item.firstLine | translate }}</span>
          <span class="text second">{{ 'dashboard.' + item.secondLine | translate }}</span>
        </div>
      </div>

      <div class="count">
        {{ item.count | toArabic }}
      </div>
    </div>
  </ng-container>
</div>
<ng-template #noDataLoaded>
  <app-skeleton [type]="'card'"></app-skeleton>
</ng-template>
